import styled from "styled-components";
import bg from "assets/images/banner-franquia-interesse.png";

export const Container = styled.section`
  width: 100%;
  height: 480px;
  margin: 0 auto;
  background: url(${bg}) no-repeat center center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 96px 32px;

  @media screen and (max-width: 540px) {
    height: auto;
    background-size: cover;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.h1`
  font-size: 72px;
  line-height: 72px;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colorScheme.primary};

  span {
    font-family: ${({ theme }) => theme.fonts.BrandontextLight};
    color: white;
  }

  @media screen and (max-width: 540px) {
    font-size: 40px;
    line-height: 40px;
  }

  @media screen and (max-width: 414px) {
    font-size: 30px;
    line-height: 30px;
  }
`;
